import { render, staticRenderFns } from "./CatalogsList.vue?vue&type=template&id=0d0ab325&scoped=true&"
import script from "./CatalogsList.vue?vue&type=script&lang=js&"
export * from "./CatalogsList.vue?vue&type=script&lang=js&"
import style0 from "./CatalogsList.vue?vue&type=style&index=0&id=0d0ab325&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0ab325",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VFlex,VLayout,VMenu,VToolbarItems})
